import useSWR from 'swr';

import { servicesAPI } from '../aon_host_statement_api';

export function useAonStatementForAccount(account_id) {
  const { data } = useSWR(
    account_id ? `/aon/account/${account_id}/statement` : null,
    () => servicesAPI.BillingServices('getAonHostStatement', account_id)
  );

  return data;
}

export function useAonAccountForCustomer(customer_id) {
  const { data } = useSWR(
    customer_id ? `aon/account/customer/${customer_id}` : null,
    () => servicesAPI.BillingServices('getAccountByCustomerId', customer_id),
    { refreshInterval: 0, revalidateOnFocus: false }
  );

  return data;
}
